import { render, staticRenderFns } from "./PartsBookItem.vue?vue&type=template&id=4d84ccf3&scoped=true"
import script from "./PartsBookItem.vue?vue&type=script&lang=ts"
export * from "./PartsBookItem.vue?vue&type=script&lang=ts"
import style0 from "./PartsBookItem.vue?vue&type=style&index=0&id=4d84ccf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d84ccf3",
  null
  
)

export default component.exports